import { IconButton, type IconButtonProps } from '@chakra-ui/react'
import { LuMoon, LuSun } from 'react-icons/lu'
import { useColorMode } from '~/theme/color-mode'

export const ColorModeButton = (props: Omit<IconButtonProps, 'aria-label'>) => {
  const { colorMode, toggleColorMode } = useColorMode()
  return (
    <IconButton
      aria-label='Toggle color mode'
      variant='ghost'
      colorPalette='gray'
      size='sm'
      onClick={toggleColorMode}
      {...props}
    >
      {colorMode === 'dark' ? <LuSun /> : <LuMoon />}
    </IconButton>
  )
}
